import { StructuredFeedback } from '@components/structured-feedback/StructuredFeedback';
import { ReactElement } from 'react';
import '@assets/styles/pages/structured-feedback.scss';

export const StructuredFeedbackPage = (): ReactElement => {
	return <StructuredFeedback />;
};
